<template>
    <div>
        <base-crud
                crudName="Usuários"
                newText="Novo Usuário"
                :table="appTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="false"
                :enableDelete="false"
                :enableView="false"
                :enableSetTestNotification="true"
                :enableExport="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                appTable: 'appTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'email', 'newsletter', 'info_by_whatsapp', 'terms_of_use', 'test_notifications', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'name', 'email'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    templates: {
                        newsletter: function (h, row, index) {
                            return (row.newsletter) ? 'Sim' : 'Não';
                        },
                        info_by_whatsapp: function (h, row, index) {
                            return (row.info_by_whatsapp) ? 'Sim' : 'Não';
                        },
                        terms_of_use: function (h, row, index) {
                            return (row.terms_of_use) ? 'Sim' : 'Não';
                        },
                        test_notifications: function (h, row, index) {
                            return (row.test_notifications) ? 'Sim' : 'Não';
                        }
                    },
                    headings: {
                        name: 'Nome',
                        email: 'E-mail',
                        newsletter: 'Novidades',
                        info_by_whatsapp: 'Novidades por WhatsApp',
                        terms_of_use: 'Termos de Uso',
                        role: 'Papel',
                        test_notifications: 'Notificações de Teste',
                        actions: 'Ações'
                    }
                },
                endPoint: 'app/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/User/Crud.vue